import { useParams } from "react-router-dom";

export const useRouterWildcard = () => {
  const { "*": value = "" } = useParams();
  return value.split("/");
};
